import React, { Component } from 'react';
import { connect } from 'react-redux';

import Vertical from './Vertical';

import { uiActions } from '../actions';

class Main extends Component {
    render() {
        return <Vertical />;
    }
}

const mapStateToProps = ({ initialContentLoaded }) => ({
    initialContentLoaded
});

const mapDispatchToProps = dispatch => {
    return {
        toggleMapPanel: () => {
            dispatch(uiActions.toggleMapPanel());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/Main.jsx